export const ENVIRONMENTS = {
  TS: {
    DEV: 'https://buspre.telefonicaseguros.es/des/mobile-services/',
    PRE: 'https://buspre.telefonicaseguros.es/pre/mobile-services/',
    PROD: 'https://bus.telefonicaseguros.es/services/mobile-services/',
  },
};
